export default function(obj) {
  return JSON.parse(JSON.stringify(obj));
}